export default __webpack_public_path__ + "static/media/call-center.1ffc91fc.jpg";